export default "__VITE_ASSET__C8KShj3Q__"